import { useContext } from 'react'
import { HatchContext } from '@/modules/hatch/HatchProvider'

export const useHatch = () => {
    return useContext(HatchContext)
}
